<template>
  <div class="container container_40 portfolio-transactions">

      <div class="text_large text_bold">
        {{ i18n.th_transaction_history() }}
      </div>

        <md-list v-if="list.length" class="md-layout portfolio-transactions__list transparent">
          <md-list-item :class="['list-item',
                                tx.state === 'rejected' ||
                                tx.state === 'failed' ? 'list-item_opacity': ''
                        ]"
                        v-for="(tx, i) in list"
                        :key="i"
                        md-expand
                        v-if="i < transactionsToShow">
            <div class="list-item_left">
              <div class="text_large text_bold"> {{ tx.name }} </div>
              <div class="text_medium text_margin">
                {{ tx.direction === 'in' ? 'from' : 'to' }} {{ tx.counterparty }}
              </div>
              <div class="text_small text_description"> {{ tx.date }} </div>
            </div>

            <div class="list-item_right">
              <div class="text_large text_bold" :class="
                ['list-item__amount',
                'list-item__amount--' + tx.direction,
                tx.state === 'pending' ? 'list-item__amount--pending' : '',
                tx.state === 'rejected' || tx.state === 'failed' ? 'list-item__amount--failed' : '']
              ">
                {{ tx.direction === 'in' ? '+' : '-' }}{{ i18n.c(tx.amount) }} {{ tx.asset }}
              </div>
              <div class="text_medium text_margin">
                {{ tx.direction === 'in' ? '+' : '-' }}{{ i18n.c(tx.quoteAmount) }} {{ tx.quoteAsset }}
              </div>
              <div class="text_small" :class="'list-item__state list-item__state--' + tx.state">
                {{ tx.state === 'confirm' ? 'success' : tx.state }}
              </div>
            </div>

            <div class="list-item__details" slot="md-expand">
              <tx-details class="info-dialog__history"
                          :tx="list[i]"/>
            </div>
          </md-list-item>
          <div class="btn-wrap margin-top">
            <md-button :to="'/history/index/' + tokenCode" class="btn md-primary">{{ i18n.lbl_view_more() }}</md-button>
          </div>
        </md-list>

        <div class="container__no-data text-center" v-else>
          <md-icon class="md-size-4x">trending_up</md-icon>
          <div class="text_xl_large">{{ i18n.th_no_transaction_history() }}</div>
          <div class="text_margin text_medium">{{ i18n.th_here_will_be_the_list() }}</div>
        </div>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { RecordTypes } from '@js/records/types'
  import { i18n } from '@js/i18n'
  import txDetails from '../history/index/History.TxDetails'

  import get from 'lodash/get'

  export default {
    name: 'portfolio-transactions',
    components: {
      txDetails
    },
    data: _ => ({
      transactionsToShow: 4,
      i18n
    }),
    props: ['token'],
    created () {
    },
    computed: {
      ...mapGetters([
        vuexTypes.transactions,
        vuexTypes.userWalletTokens
      ]),
      tokenCode () {
        return this.token ? this.token.code : null
      },
      list () {
        return (get(this.transactions, `${this.tokenCode}.records`) || [])
          .reduce((list, item) => {
            if (item instanceof RecordTypes.MatchRecord) {
              item.transactions.forEach(tx => { list.push(tx) })
              return list
            }
            list.push(item)
            return list
          }, [])
      }
    },
    methods: {
      ...mapActions({
        loadList: vuexTypes.GET_TX_LIST
      })
    },
    watch: {
      token (value) {
        this.loadList({risk_type: 'all', code: value.code})
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .portfolio-transactions {
    width: 100%;
    display: flex;
    flex-direction: column;

    @include respond-to(medium) {
      max-width: inherit;
    }

    & /deep/ .md-list-expand-icon {
      display: none;
    }

    & /deep/ .md-list-item-content {
      padding: 22px 0;
    }

    & .list-item {

     &_right {
       text-align: right;
     }

      &_opacity {
        opacity: .7;
      }

      &__details {
        padding: 12px 48px 12px 0;
        border-top: 1px solid $col-border;
      }

      &__amount--in { color: $green; }
      &__amount--out { color: $col-error; }
      &__amount--pending { color: $yellow-push; }
      &__amount--failed { color: rgba($dark-grey, .5); }


      &__state--success { color: $green; }
      &__state--pending { color: $yellow-push; }
      &__state--rejected,
      &__state--failed { color: $col-invalid; }

      &:not(:first-child) {
        border-top: 1px solid #e8e8e8;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/portfolio/Portfolio.Transactions.vue